import React, { useCallback, useEffect, useState } from "react";
import { Button, CircularProgress, Tooltip } from "@mui/material";
import { StopCircle as StopCircleIcon } from "@mui/icons-material";
import { toast } from "react-toastify";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001";

const getAdminToken = () =>
  localStorage.getItem("admin_token") || localStorage.getItem("auth_token");

const StopAllGamesHeaderButton = () => {
  const [anyActive, setAnyActive] = useState(false);
  const [busy, setBusy] = useState(false);

  const fetchStatus = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/settings/stop-all-games`, {
        credentials: "include",
        headers: {
          Authorization: `Bearer ${getAdminToken()}`,
        },
      });
      if (!res.ok) return;
      const data = await res.json();
      setAnyActive(!!data.anyActive);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    fetchStatus();
    const id = setInterval(fetchStatus, 8000);
    return () => clearInterval(id);
  }, [fetchStatus]);

  const handleStopAll = async () => {
    if (busy || !anyActive) return;
    const confirmed = window.confirm(
      "Stop all live games? This will end Beerillioner, HoL, and Insta Quiz sessions, and return Spin the Wheel to the default wheel."
    );
    if (!confirmed) return;

    setBusy(true);
    try {
      const res = await fetch(`${API_BASE}/api/settings/stop-all-games`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAdminToken()}`,
        },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        throw new Error(data.error || "Failed to stop games");
      }

      setAnyActive(false);
      if (data.stopped?.length) {
        toast.success(`Stopped: ${data.stopped.join(", ")}`);
      } else {
        toast.info("No games were running");
      }
    } catch (err) {
      toast.error(err.message || "Failed to stop games");
    } finally {
      setBusy(false);
      fetchStatus();
    }
  };

  const title = anyActive
    ? "End every live session: Beerillioner, HoL, Insta Quiz, and Spin the Wheel (back to default)"
    : "No live game sessions are active";

  return (
    <Tooltip title={title}>
      <span>
        <Button
          size="small"
          variant="contained"
          startIcon={
            busy ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <StopCircleIcon sx={{ fontSize: 16 }} />
            )
          }
          disabled={busy || !anyActive}
          onClick={handleStopAll}
          sx={{
            bgcolor: anyActive ? "#c62828" : "rgba(0,0,0,0.25)",
            color: "#fff",
            fontWeight: 700,
            textTransform: "none",
            fontSize: "0.75rem",
            height: 32,
            px: 1.5,
            whiteSpace: "nowrap",
            "&:hover": {
              bgcolor: anyActive ? "#b71c1c" : "rgba(0,0,0,0.4)",
            },
            "&.Mui-disabled": {
              bgcolor: "rgba(0,0,0,0.2)",
              color: "rgba(255,255,255,0.55)",
            },
          }}
        >
          Stop All Games
        </Button>
      </span>
    </Tooltip>
  );
};

export default StopAllGamesHeaderButton;
